import { Options, setup } from "vue-class-component";
import { Model, Prop, Vue } from "vue-property-decorator";
import OurCarsLeftFilterColorListComponent from "@/shared/vehicles/left-filter/color-list/color-list.vue";
import { ColorFilterItemDto } from "@/shared/api-contract/api-contract";
import "./color-filter.scss";
import { useI18n } from "@/shared/composables/use-i18n";

@Options({
    components: {
        "app-color-filter": OurCarsLeftFilterColorListComponent,
    },
})
export class ColorFilter extends Vue {
    @Model("modelValue", { required: true })
    model!: readonly string[];
    @Prop({ type: Array, required: true })
    options!: readonly ColorFilterItemDto[];
    i18n = setup(useI18n);
    isOpen = false;

    @Prop({ type: Boolean, default: false })
    selectMode!: boolean;

    @Prop({ type: Number })
    selectModeForMainFilter?: 1 | 2 | 3 | 4;

    @Model("selected")
    selectedModel!: boolean;

    buttonClick(event: UIEvent) {
        if (this.selectMode) {
            const target = event.target;
            const innerButtonClick =
                target instanceof Element && target.closest(".filter-btn__block");
            if (!innerButtonClick) {
                this.selectedModel = !this.selectedModel;
            }
        } else {
            this.isOpen = !this.isOpen;
        }
    }

    innerButtonClick() {
        if (this.selectMode) {
            this.isOpen = !this.isOpen;
        }
    }
}
